import { deviceManagement } from './modules/deviceManagement'

const ItilLayOut = () => import(/*webpackChunkName:'itil'*/'@/page/itil/itilLayOut.vue')

export const itil={
    path:'/itil',
    name: '运维中心',
    component: ItilLayOut ,
    redirect:'/main/equipment/station',
    children:[
        deviceManagement,
    ]
}